import React, { memo } from 'react'
import cn, { Argument as ClassName } from 'classnames'
import { Card } from 'primereact/card'
import { Button } from 'primereact/button'

import useText from '../../../common/hooks/useText'

export type BillingPaymentDetailsWidgetProps = {
    className?: ClassName
    style?: React.CSSProperties
    billableConnectors: number
    isCustomer: boolean
    hasActiveSubscription: boolean
    onManagePayments: () => void
}

export const BillingPaymentDetailsWidget = memo(function BillingPaymentDetailsWidget({
    className,
    style,
    billableConnectors,
    isCustomer,
    hasActiveSubscription,
    onManagePayments,
}: BillingPaymentDetailsWidgetProps): React.ReactElement {
    const text = useText()

    return (
        <Card title={text('lblDetails')} className={cn(className)} style={style}>
            <div className="flex flex-column gap-3">
                {isCustomer ? (
                    <>
                        {hasActiveSubscription ? (
                            <p className="m-0">
                                {text('lblYourNextInvoiceWillInclude', {
                                    chargerCount: billableConnectors,
                                })}
                            </p>
                        ) : null}

                        <div>
                            <p>{text('lblCustomerPortalDescription')}</p>

                            <Button onClick={onManagePayments} label={text('lblManagePayment')} icon="pi pi-cog" />
                        </div>
                    </>
                ) : null}

                <p className="m-0 text-sm text-gray-500">{text('lblPaymentDetailLine')}</p>
            </div>
        </Card>
    )
})
